import { Cloud } from '@cast/shared-types';

import { EnhancedEdgeLocation, EdgeLocationAddonName } from './types';

import { ClientSideSearchCriterion } from '@cast/shared-search-ui';

export const CUSTOM_EDGE_PROVIDER = 'custom' as const;

export const EDGE_LOCATION_ADDON_NAME_TO_DISPLAY_NAME_MAP: Record<
  EdgeLocationAddonName,
  string
> = {
  [EdgeLocationAddonName.NvidiaGpuOperator]: 'NVIDIA GPU Operator',
  [EdgeLocationAddonName.NvidiaDra]: 'NVIDIA Dynamic Resource Allocation',
  [EdgeLocationAddonName.NvidiaNetworkOperator]: 'NVIDIA Network Operator',
  [EdgeLocationAddonName.OciCsi]: 'Oracle Cloud Infrastructure CSI driver',
};

export const edgeLocationDrawerKey = 'open-edge-location-drawer';
export const edgeLocationProviderKey = 'edge-location-provider';
export const edgeLocationRegionKey = 'edge-location-region';
export const edgeLocationProviderProjectIdKey =
  'edge-location-provider-project-id';

export const EDGE_PROVIDER_NAME_MAP = {
  [Cloud.gcp]: 'GCP',
  [Cloud.aws]: 'AWS',
  [Cloud.oracle]: 'Oracle',
  [Cloud.nebius]: 'Nebius',
  [Cloud.unknown]: 'Unknown',
  [CUSTOM_EDGE_PROVIDER]: 'Custom',
} as const;

export const SUPPORTED_EDGE_PROVIDERS = [
  Cloud.aws,
  Cloud.gcp,
  Cloud.oracle,
  CUSTOM_EDGE_PROVIDER,
] as const;

export const stateCriterion: ClientSideSearchCriterion<EnhancedEdgeLocation> = {
  key: 'mappedState',
  prop: 'mappedState',
};

export const cloudProvidersCriterion: ClientSideSearchCriterion<EnhancedEdgeLocation> =
  {
    key: 'provider',
    prop: 'provider',
  };

export const edgeLocationsCriteria = [stateCriterion, cloudProvidersCriterion];

export enum GlobalCapacityTabs {
  EDGE_LOCATIONS = 'edge-locations',
  AVAILABLE_REGIONS = 'available-regions',
}
